import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import { CookieAlert } from './styles';

export default function CookiesAlert({ program }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const cookies = localStorage.getItem('cookies-accepted');
    setActive(!(cookies && cookies != null));
  }, []);

  const accept = () => {
    localStorage.setItem('cookies-accepted', true);
    setActive(false);
  };

  return active ? (
    <CookieAlert program={program}>
      <div>
        <h1>ACEITAÇÃO POLÍTICA DE COOKIES</h1>
        <p>
          “Para aperfeiçoamento do funcionamento, bem como a segurança do site, nós recolhemos
          seus dados pessoais despersonalizados, proporcionando-lhe a melhor experiência de
          navegação possível. Através do link
          {' '}
          <Link to="/privacy-policies">“Política de Cookies”</Link>,
          você pode consultar a descrição detalhada do processo de processamento. A descrição
          detalhada das tecnologias usadas por nós e a possibilidade de cancelamento do seu
          consentimento com o uso dos meios indicados,
          é apresentada também no link referido.
          Ao clicar no botão "Aceitar", você concorda expressamente com o processamento de seus
          dados pessoais para os fins acima mencionados”.
        </p>
        <div><button type="button" onClick={accept} >Aceitar</button></div>
      </div>
    </CookieAlert>
  ) : <></>;
}

CookiesAlert.propTypes = {
  program: PropTypes.string,
};

CookiesAlert.defaultProps = {
  program: 'cnhpop',
};
